<template>
  <div class="row lineItem d-flex h-auto justify-content-between">
      <div class="col-9 lineItemLeft d-flex justify-content-left h-100">
        <a :href="'?isbn=' + isbn"><img :src="coverURL" class="py-2"/></a>
        <div class="px-2 py-1 d-flex justify-content-between flex-column lineItemText">
          <div class="textContainer">
            <h3>{{ title }}</h3>
            <p>{{ primaryAuthor }}</p>
            <p>{{ format }}</p>
          </div>
          <div>
          <div class="input-group my-2 quantity">
            <div class="input-group-prepend">
              <button class="btn btn-secondary" aria-label="Decrease quantity" data-type="link-event" data-category="Ecommerce" data-action="Decrease Quantity" :data-label="isbn" type="button" @click="changeQuantity(-1)"><font-awesome-icon :icon="['fas', 'minus']" /></button>
            </div>
            <label :id="'quantityLabel' + id" :for="'quantity' + id" class="sr-only">Quantity</label>
            <input :id="'quantity' + id" :value="quantity" @change="setQuantity($event.target.value)" type="number" pattern="[0-9]*" class="form-control text-center" placeholder="" :aria-describedby="'quantityLabel' + id">
            <div class="input-group-append">
              <button class="btn btn-secondary" aria-label="Increase quantity" data-type="link-event" data-category="Ecommerce" data-action="Increase Quantity" :data-label="isbn" :class="{ 'disabled': quantity == 24 }" type="button" @click="changeQuantity(1)"><font-awesome-icon :icon="['fas', 'plus']" /></button>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="col-3 lineItemRight h-auto d-flex flex-column justify-content-between text-right">
          <div>
            <button type="button" :aria-label="'Remove ' + title + ' from cart.'" data-type="link-event" data-category="Ecommerce" data-action="Remove from Cart" :data-label="isbn" class="btn btn-light" @click="cancelItem()"><font-awesome-icon :icon="['fas', 'xmark']" /></button>
          </div>
          <p class="price pb-2 ms-auto">{{ useFormatPrice(quantity * price) }}</p>
      </div>
  </div>
</template>

<script>
import { useFormatPrice } from '../helpers/formatPrice.js'

export default {
  name: 'CartItem',
  props: {
    id: String,
    title: String,
    primaryAuthor: String,
    isbn: Number,
    format: String,
    quantity: Number,
    price: Number,
    coverURL: String
  },
  created() {
  },
  computed: {
  },
  methods: {
    useFormatPrice: useFormatPrice,
    setQuantity(amount){
      let quantity = (parseInt(amount) <= 24) ? parseInt(amount) : 24;
      this.$store.dispatch('changeItemQuantity', {
        variantId: this.id,
        quantity: quantity
      })
    },
    changeQuantity(amount) {
        let updatedQuantity = this.quantity + amount;
        this.$store.dispatch('changeItemQuantity', {
          variantId: this.id,
          quantity: updatedQuantity
        })
    },
    cancelItem(){
      this.$store.dispatch('removeFromCart', {
        variantId: this.id
      })
    }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.svg-inline--fa{
    pointer-events: none;
}
.lineItem{
            /* height: 130px; */
            height: 32%;
            border-bottom: 1px solid rgba(0,0,0,.125);
}
.lineItemLeft{
            height: 100%;
}
.lineItemLeft img{
            /* height: 100%; */
            height: 8.7rem;
            width: auto;
            max-width: 5.1rem;
            object-fit: cover;
}
.lineItemRight {
            height: 100%;
}
.lineItemText{
  height: 100%;
}
.shopping-cart-interior h3 {
            font-size: 1.25rem;
            margin-bottom: 0rem;
            /* white-space: nowrap; */
            overflow: hidden;
            max-height: 10rem;
            display: -webkit-box!important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
}
.shopping-cart-interior p {
            margin-bottom: 0rem;
            line-height: 1.5rem !important;
}
.shopping-cart-interior .btn {
            text-align: right;
}
.shopping-cart-interior .btn-light{
            background-color: white;
            border: none;
            font-size: 1.25rem;
            padding-right: 0rem;
            padding-top: 0rem;
            float: right;
}
.shopping-cart-interior .btn-secondary{
            background-color: rgba(0,0,0,.125);
            color: black;
}
.price {
            font-size: 1.25rem;
            font-weight: 600;
}
.quantity {
            width: 7.5rem !important;
}
.textContainer {
  width: 140%;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
